import axios from 'axios';
const searchCondition = (queryParams) => {
  if (queryParams.searchText) {
    return queryParams.searchText.trim();
  }
  if (queryParams.filter?.userName) {
    return queryParams.filter.userName.trim();
  }
  if (queryParams.filter?.fullName) {
    return queryParams.filter.fullName.trim();
  }
  if (queryParams.filter?.phoneNumber) {
    return queryParams.filter.phoneNumber.trim();
  }
  return '';
};

export async function getMemberSubscriptionList(queryParams) {
  const params = {
    pageIndex: queryParams.pageNumber,
    pageSize: queryParams.pageSize,
    sortText: `${queryParams.sortField || 'id'} ${queryParams.sortOrder || 'asc'}`,
    searchText: searchCondition(queryParams),
  };
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/Subscription/Get`, params);
  return response.data;
}

export async function getMemberSubscriptionById(memberSubscriptionId) {
  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/Subscription/${memberSubscriptionId}`
  );
  return response.data;
}

export async function createMemberSubscription(memberSubscription) {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/Subscription`,
    memberSubscription
  );
  return response.data;
}

export async function createOrUpdateMemberSubscription(memberSubscription) {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/Subscription`,
    memberSubscription
  );
  return response.data;
}

export async function deleteMemberSubscription(memberSubscriptionId) {
  const response = await axios.delete(
    `${process.env.REACT_APP_API_URL}/Subscription?Id=${memberSubscriptionId}`
  );
  return response.data;
}

export async function getSubscriptionList(searchText) {
  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/Subscription/SubscriptionList?searchText=${searchText}`
  );
  return response.data;
}
